/*
 *  Employed__Branding__Selector.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import React, { useState } from "react";
import * as SC from "./styles";
import { withRouter } from "react-router-dom";
import { Widget } from "@typeform/embed-react";
import { useTranslation } from "react-i18next";
import { withRefluxStore } from "../../../Stores";
import { Store__System } from "@talentbait/shared-components";

import logger from "../../../utils/LoggerFrontend.js";
import { Helmet } from "react-helmet";

const TYPEFORM_QUESTIONS_REF = {
  DASHBOARD: "82b3c982-4761-4678-9695-3d03539e8a5c",
  HUBSPOT: "01HGZH4M72TBK09FFBCRZD4BTC"
};

const EmployerBrandingSelector = ({ history, userProfile, organization }) => {
  const { t } = useTranslation();

  const [showHubspot, setShowHubspot] = useState(false);

  const hiddenFormFields = {
    user_id: userProfile.userId,
    email: userProfile.email
  };

  const emitEventTrack = (eventName, data) => {
    if (window.analytics) {
      window.analytics.track(eventName, {
        source: "Employer Branding",
        questionRef: data.ref,
        userId: userProfile.userId,
        userName: userProfile.userName,
        email: userProfile.email,
        organizationId: organization.id,
        organizationName: organization.name
      });
    }
  };

  const handleQuestionChange = (data) => {
    logger.log("EmployerBranding:onQuestionChange", "Question changed", { data });

    emitEventTrack("Question Changed", data);
  };
  const handleReady = (data) => {
    logger.log("EmployerBranding:handleReady", "Ready: ", { data });

    emitEventTrack("Typeform Start", data);
  };
  const handleStarted = (data) => {
    logger.log("EmployerBranding:handleStarted", "Start: ", { data });
  };
  const handleSubmit = (data) => {
    logger.log("EmployerBranding:handleSubmit", "Submit: ", { data });
  };
  const handleHeightChange = (data) => {
    logger.log("EmployerBranding:handleHeightChange", "Height: ", { data });
  };
  const handleEndingButtonClick = (data) => {
    logger.log("EmployerBranding:handleEndingButtonClick", "Ending:", { data });
    emitEventTrack("Ending button clicked", data);

    if (data.ref === TYPEFORM_QUESTIONS_REF.DASHBOARD) {
      emitEventTrack("Dashboard redirection", data);

      return history.push("/dashboard");
    }

    if (data.ref === TYPEFORM_QUESTIONS_REF.HUBSPOT) {
      emitEventTrack("Hubspot calendar redirection", data);

      setShowHubspot(true);
    }
  };
  const handleClose = (data) => {
    logger.log("EmployerBranding:handleClose", "Close: ", { data });
  };

  return (
    <SC.EmployerBrandingWrapper className="fade-in">
      <SC.Header>{t("Create a new Campaign")}</SC.Header>
      {showHubspot ? (
        <>
          <Helmet>
            <script
              type="text/javascript"
              src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
            ></script>
          </Helmet>
          <div
            className="meetings-iframe-container"
            data-src="https://meetings.hubspot.com/neele-mevius/austausch-mit-emely-neele?embed=true"
          ></div>
        </>
      ) : (
        <Widget
          id="HFRD49t7"
          style={{ width: "50%", height: "100%", marginTop: "50px" }}
          onQuestionChanged={handleQuestionChange}
          onReady={handleReady}
          onStarted={handleStarted}
          onSubmit={handleSubmit}
          onHeightChanged={handleHeightChange}
          onEndingButtonClick={handleEndingButtonClick}
          onClose={handleClose}
          autoResize
          hidden={hiddenFormFields}
        />
      )}
    </SC.EmployerBrandingWrapper>
  );
};

export default withRefluxStore(
  withRouter(EmployerBrandingSelector),
  [Store__System],
  ["userProfile", "organization"]
);
